// Gritos de TRUCO, SEIS, NOVE e DOZE. Quem gravou a própria voz (Prata e Ouro) grita com ela;
// os outros, e os bots, com a voz sintética do aparelho, num tom diferente para cada lugar.
import type { Grito } from '@truco6/mesa/protocolo';
import { preferencias } from './preferencias.ts';
import { anotar, tocarGravacao } from './som.ts';

export { GRITOS, type Grito } from '@truco6/mesa/protocolo';
export const GRITO_DO_NIVEL: Record<number, Grito> = { 3: 'truco', 6: 'seis', 9: 'nove', 12: 'doze' };
const FALA: Record<Grito, string> = { truco: 'Truco!', seis: 'Seis!', nove: 'Nove!', doze: 'Doze!' };
const TOM = [1.05, 0.8, 1.25, 0.9, 1.35, 0.7];

let vozes: SpeechSynthesisVoice[] = [];
function carregarVozes(): void {
  try { vozes = speechSynthesis.getVoices(); } catch { vozes = []; }
}
if (globalThis.speechSynthesis) {
  carregarVozes();
  speechSynthesis.addEventListener?.('voiceschanged', carregarVozes);
}
function vozPtBr(): SpeechSynthesisVoice | null {
  const norm = (l: string) => l.replace('_', '-').toLowerCase();
  return vozes.find((v) => norm(v.lang) === 'pt-br') ?? vozes.find((v) => norm(v.lang).startsWith('pt')) ?? null;
}

export function falar(grito: Grito, lugarRel: number): void {
  try {
    const u = new SpeechSynthesisUtterance(FALA[grito]);
    const voz = vozPtBr();
    if (voz) u.voice = voz;
    u.lang = 'pt-BR';
    u.rate = 1.15;
    u.pitch = TOM[lugarRel % 6]!;
    u.volume = 1;
    speechSynthesis.cancel();
    speechSynthesis.speak(u);
  } catch { /* aparelho sem voz sintética */ }
}

export function gritar(nivel: number, lugarRel: number, gravacao: AudioBuffer | null): void {
  const grito = GRITO_DO_NIVEL[nivel] ?? 'truco';
  const gravada = !!gravacao && preferencias().vozesGravadas;
  anotar('grito:' + grito + (gravada ? ':gravado' : ':padrao'));
  if (!preferencias().som) return;
  if (gravada && tocarGravacao(gravacao)) return;
  falar(grito, lugarRel);
}
